import { Injectable } from '@angular/core';

import { Actions, Effect, ofType } from '@ngrx/effects';

import { Observable, of, zip } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import {
  DocumentActionTypes,
  DeleteDocument,
  DeleteDocumentSuccess,
  DeleteDocumentFailure,
} from '../actions/document.actions';
import { ReloadCrpList } from 'store/actions/customer.actions';

import { DocumentsService } from 'modules/core/services/documents.service';

@Injectable()
export class DocumentEffects {
  constructor(private actions$: Actions,
              private documentService: DocumentsService) { }

  @Effect() deleteDocument$: Observable<any> = this.actions$.pipe(
    ofType<DeleteDocument>(DocumentActionTypes.DELETE_DOCUMENT),
    mergeMap((res: any) => {
      return zip(of(res.payload), this.documentService.deleteDocument(res.payload)).pipe(
        mergeMap(([crpId, deleteResponse]: [any, any]) => {
          return [
            new DeleteDocumentSuccess(deleteResponse),
            new ReloadCrpList(deleteResponse)
          ];
        }),
        catchError(error => {
          return of(new DeleteDocumentFailure(error.message));
        })
      );
    })
  );
}
